import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'

import { RemoveItemModalFooter, RemoveItemModalText } from '../EcosystemData/style'

const RemoveEcosystemModal = ({ itemName, item, toggleModal, confirm }) => {
  function handleCloseModal() {
    toggleModal(false)
  }

  function confirmRemove() {
    confirm(item.id, item.historyId)
    toggleModal(false)
  }

  return (
    <>
      <RemoveItemModalText>
        Are you sure you want to permanently remove <b>{itemName}</b> from the list? This action cannot be undone.
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type="secondary" onClick={handleCloseModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="destructive" onClick={confirmRemove}>
          <FormattedMessage id="yesRemove" />
        </Button>
      </RemoveItemModalFooter>
    </>
  )
}

export default RemoveEcosystemModal
